import { render, staticRenderFns } from "./DailyServices.vue?vue&type=template&id=53f9fb56&scoped=true"
import script from "./DailyServices.vue?vue&type=script&lang=js"
export * from "./DailyServices.vue?vue&type=script&lang=js"
import style0 from "./DailyServices.vue?vue&type=style&index=0&id=53f9fb56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f9fb56",
  null
  
)

export default component.exports